import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SystemService } from '../../Services/system.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dataprocess',
  templateUrl: './dataprocess.component.html',
  styleUrls: ['./dataprocess.component.css']
})
export class DataprocessComponent implements OnInit {
  selectedItem = 'import';
  stages = [
    { name: 'import', icon: 'upload' },
    { name: 'prepare', icon: 'tableproperties' },
    { name: 'goldenrecord', icon: 'detailslayout' },
    { name: 'export', icon: 'download' }
  ];

  constructor(public router: Router, public translate: TranslateService, public systemService: SystemService) {
    this.systemService.currentNavigationTitle = this.translate.instant('DatenProzess');
    this.selectStage = this.selectStage.bind(this);
  }

  ngOnInit(): void {
    const lastfragment = this.getLastRouteElement();
    if (this.stages.some((x) => x.name == lastfragment)) this.selectedItem = lastfragment;
  }

  getLastRouteElement() {
    const url = this.router.url.split('/');
    return url[url.length - 1];
  }

  selectStage(stage: string) {
    this.selectedItem = stage;
    this.router.navigate(['dataprocess', stage]);
  }
}
